import { Controller } from '@hotwired/stimulus';

// Light per-section note: toggles the inline note editor open/closed.
// The form submits to sections#update (turbo), which re-renders the whole section
// with the saved annotation — so no state needs to survive across the swap.
export default class extends Controller {
  static targets = ['form', 'trigger'];

  toggle(event) {
    event.preventDefault();
    this.formTarget.classList.toggle('d-none');
    if (this.hasTriggerTarget) this.triggerTarget.classList.toggle('d-none');
    if (!this.formTarget.classList.contains('d-none')) {
      const field = this.formTarget.querySelector('textarea');
      if (field) field.focus();
    }
  }
}
